export default __webpack_public_path__ + "static/media/logo-dark.acf69e90.svg";